/**
 * BarcodeLookupUseCase - Service to fetch product information from external APIs based on barcode.
 */

export interface ExternalProductInfo {
    name: string;
    description: string;
    image?: string;
    brand?: string;
}

/**
 * Buscador de productos Multi-Fuente
 */
export async function lookupProductByBarcode(barcode: string): Promise<ExternalProductInfo | null> {
    if (!barcode || barcode.length < 8) return null;

    // Intentar con Open Food Facts (Fuente 1 - Global)
    const off = await tryOpenFoodFacts(barcode);
    if (off) return off;

    // Intentar con UPCitemdb (Fuente 2 - Comercial/Global)
    const upc = await tryUPCitemdb(barcode);
    if (upc) return upc;

    return null;
}

async function tryOpenFoodFacts(barcode: string): Promise<ExternalProductInfo | null> {
    try {
        // Usamos la API v2 que es más robusta
        const response = await fetch(`https://world.openfoodfacts.org/api/v2/product/${barcode}.json`, {
            headers: { 'User-Agent': 'EasyPOS-App/1.0 (contact: info@creatives3d.com)' }
        });
        
        if (!response.ok) return null;
        const data = await response.json();

        if (data.status === 'success' || data.status === 1) {
            const p = data.product;
            return {
                name: p.product_name_es || p.product_name || p.generic_name || "",
                description: p.brands ? `${p.brands} - ${p.quantity || ''}` : "",
                brand: p.brands || "",
                image: p.image_url || null
            };
        }
    } catch (e) {
        console.warn("OFF Lookup failed:", e);
    }
    return null;
}

async function tryUPCitemdb(barcode: string): Promise<ExternalProductInfo | null> {
    try {
        const response = await fetch(`https://api.upcitemdb.com/prod/trial/lookup?upc=${barcode}`);
        if (!response.ok) return null;
        const data = await response.json();

        if (data.items && data.items.length > 0) {
            const item = data.items[0];
            return {
                name: item.title || "",
                description: item.description || "",
                brand: item.brand || "",
                image: (item.images && item.images.length > 0) ? item.images[0] : null
            };
        }
    } catch (e) {
        console.warn("UPCitemdb Lookup failed:", e);
    }
    return null;
}
